<template>
  <div class="wrapper">
    <page-header/>
    <kiosk-settings-checker>
      <kiosk-login v-if="!authenticated" @authenticated="handleAuthenticated"/>
      <kiosk-search v-else-if="step === 'search'" @pick="handlePick" @unauthorized="handleUnauthorized"/>
      <kiosk-confirm v-else-if="step === 'confirm'" :group="selectedGroup" @signed-in="handleSignedIn" @back="reset" @unauthorized="handleUnauthorized"/>
      <kiosk-terms v-else-if="step === 'terms'" :group="selectedGroup" @signed-in="handleSignedIn" @back="reset" @unauthorized="handleUnauthorized"/>
      <kiosk-welcome v-else-if="step === 'welcome'" :client-full-name="selectedGroup ? selectedGroup.clientFullName : ''" @reset="reset"/>
    </kiosk-settings-checker>
    <page-footer/>
  </div>
</template>

<script>
import { KioskSignInSettingCacheMixin } from '@/mixins/Kiosk/KioskSignInSettingCacheMixin'
import { TimeZoneCacheMixin } from '@/mixins/Booking/TimeZoneCacheMixin'
import { WebApi } from '@/services/WebApi'
import PageHeader from '@/components/ClientRegistration/Layout/PageHeader.vue'
import PageFooter from '@/components/ClientRegistration/Layout/PageFooter.vue'
import KioskSettingsChecker from './KioskSettingsChecker.vue'
import KioskLogin from './KioskLogin.vue'
import KioskSearch from './KioskSearch.vue'
import KioskConfirm from './KioskConfirm.vue'
import KioskTerms from './KioskTerms.vue'
import KioskWelcome from './KioskWelcome.vue'

export default {
  name: 'KioskPage',
  mixins: [KioskSignInSettingCacheMixin, TimeZoneCacheMixin],
  data () {
    return {
      authenticated: false,
      checkingAuth: true,
      step: 'search',
      selectedGroup: null
    }
  },
  computed: {
    requireTemplate () {
      return !this.kioskSignInSetting || this.kioskSignInSetting.requireTemplate !== false
    }
  },
  created () {
    this.checkAuth()
  },
  methods: {
    checkAuth () {
      const self = this
      WebApi.get('Kiosk/Interstitial')
        .then(() => {
          self.authenticated = true
          self.reset()
        })
        .catch(() => { self.authenticated = false })
        .finally(() => { self.checkingAuth = false })
    },
    handleAuthenticated () {
      this.authenticated = true
      this.reset()
    },
    handlePick (group) {
      this.selectedGroup = group
      this.step = this.requireTemplate ? 'terms' : 'confirm'
    },
    handleSignedIn () {
      this.step = 'welcome'
    },
    handleUnauthorized () {
      this.authenticated = false
      this.reset()
    },
    reset () {
      this.step = 'search'
      this.selectedGroup = null
    }
  },
  components: {
    'page-header': PageHeader,
    'page-footer': PageFooter,
    'kiosk-settings-checker': KioskSettingsChecker,
    'kiosk-login': KioskLogin,
    'kiosk-search': KioskSearch,
    'kiosk-confirm': KioskConfirm,
    'kiosk-terms': KioskTerms,
    'kiosk-welcome': KioskWelcome
  }
}
</script>
